/**
 * @generated SignedSource<<d3bba305f1f51d8c85c7226ceea197af>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProfileNew$data = {
  readonly user: {
    readonly email?: string | null;
    readonly picture: AGG$URL;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"AccountMenu_triggerQuery">;
  readonly " $fragmentType": "ProfileNew";
};
export type ProfileNew$key = {
  readonly " $data"?: ProfileNew$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileNew">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "atlassianAccountId"
    }
  ],
  "kind": "Fragment",
  "name": "ProfileNew",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "accountId",
          "variableName": "atlassianAccountId"
        }
      ],
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "picture"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "email"
            }
          ],
          "type": "AtlassianAccountUser"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "AccountMenu_triggerQuery"
    }
  ],
  "type": "Query"
};

(node as any).hash = "c7d68b20b1812fe91c21fb91fd572c86";

export default node;
